<template>
  <div class="develop animate__animated " >
    <div class="develop-title">
      <span>发展历程</span>
    </div>
    <div class="develop-content">
      <vue-horizontal-timeline :items="List" title-attr="year" content-attr="description" class="timeline"></vue-horizontal-timeline>
    </div>
  </div>
</template>

<script>
  import { VueHorizontalTimeline } from "vue-horizontal-timeline";
export default {
  name: "Company",
  components:{VueHorizontalTimeline},
  data(){
    return{
      clickitem: null,
      List:{},
    }
  },
  created() {
    this.GetListData()
  },
  methods:{
    GetCurrent(item){
      this.clickitem=item.year;
      this.CItem=item;
    },
    GetListData(){
        this.$axios.post('/api/develop/getAll',{'pageNumber':1,'pageSize':100}).then(res=>{
          this.List=res.data.data.records;
          this.clickitem=this.List[0].year
        })
    }
  }
}
</script>

<style lang="less" scoped>

.develop{
  width: 74.5vw;
  margin:0 auto;
  padding: 20px 0;
  .develop-title{
    padding: 30px 0 60px 0;
    text-align: center;
    span{
      height: 32px;
      font-size: 32px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 48px;
      letter-spacing: 1px;
    }
  }
  .develop-content{

  }
}
</style>